const prefix = 'fac';
const iconName = 'nested-link';
const width = 12;
const height = 12;
const ligatures = [];
const unicode = null;
const svgPathData =
  'M2.5,0 C3.88071,0 5,1.11929 5,2.5 C5,3.73022 4.11141,4.7529 2.94104,4.96122 C2.76778,6.82423 4.20611,8.43865 6.04779,8.51107 C6.27513,7.36444 7.28661,6.5 8.5,6.5 C9.88071,6.5 11,7.61929 11,9 C11,10.3807 9.88071,11.5 8.5,11.5 C7.29475,11.5 6.28871,10.6471 6.05247,9.51197 C3.645,9.44345 1.75181,7.35945 1.93945,4.93691 C0.828631,4.68244 0,3.68799 0,2.5 C0,1.11929 1.11929,0 2.5,0 Z M8.49647,7.25 C7.52997,7.25 6.74647,8.0335 6.74647,9 C6.74647,9.9665 7.52997,10.75 8.49647,10.75 C9.46297,10.75 10.2465,9.9665 10.2465,9 C10.2465,8.0335 9.46297,7.25 8.49647,7.25 Z M2.49652,0.75 C1.53002,0.75 0.746521,1.5335 0.746521,2.5 C0.746521,3.4665 1.53002,4.25 2.49652,4.25 C3.46302,4.25 4.246521,3.4665 4.246521,2.5 C4.246521,1.5335 3.46302,0.75 2.49652,0.75 Z';

export const faNestedLink = {
  // Use a prefix like 'fac' that doesn't conflict with a prefix in the standard Font Awesome styles
  // (So avoid fab, fal, fas, far, fa)
  prefix,
  iconName, // Any name you like
  icon: [
    width, // width
    height, // height
    ligatures, // ligatures
    unicode, // unicode (if relevant)
    svgPathData, // svg path data
  ],
};
